export const UPDATE_LOGGEN_CONFIG = 'UPDATE_LOGGEN_CONFIG'
